const INTERACTIONS = {
  LOAD_VIEWER_CONTROLLER: "wix.forms.load-viewer-controller",
  SUBMIT_FORM: "wix.forms.submit-form"
};
export {
  INTERACTIONS
};
//# sourceMappingURL=interactions.js.map
